import { render, staticRenderFns } from "./LawSecurityDepositMethodForm.vue?vue&type=template&id=2a8297e8&"
import script from "./LawSecurityDepositMethodForm.vue?vue&type=script&lang=js&"
export * from "./LawSecurityDepositMethodForm.vue?vue&type=script&lang=js&"
import style0 from "./LawSecurityDepositMethodForm.vue?vue&type=style&index=0&id=2a8297e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports